import React, { useState, Fragment } from "react";
import {
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import SearchProfiles from "./Search/SearchProfile/SearchProfiles";
import { PATH_SECURITY } from "../../utils/routeConstants";
import { securityPaths } from "../../utils/enums";
import Permissions from "./Permissions";
import { getAccessPermission } from "../../reducers/PermissionsReducer";

const mainMenu = [
  {
    type: "menu",
    label: "Security",
    slug: PATH_SECURITY,
    submenu: [
      { type: "link", label: "Profiles", path: "profiles" },
      { type: "link", label: "Roles / Permissions", path: "roles-permissions" },
    ],
  },
];

const SecuritySidebar = () => {
  const [menuState, setMenuState] = useState({ Security: true });
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();

  const securityProfilesPermission = getAccessPermission(
    "security",
    "Profiles",
    "any"
  );
  const securityProfilesReadPermission = securityProfilesPermission?.Read;

  const securityRolePermission = getAccessPermission(
    "security",
    "Roles And Permissions",
    "any"
  );
  const securityRolePermissionRead = securityRolePermission?.Read;

  const toggleMenu = (label) => {
    setMenuState((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const renderItem = (item) => {
    if (item.type === "link") {
      if (
        (item.path === "profiles" && !securityProfilesReadPermission) ||
        (item.path === "roles-permissions" && !securityRolePermissionRead)
      ) {
        return null;
      }
      const isActive = location.pathname.endsWith(item.path);
      return (
        <ListItemButton
          key={item.path}
          onClick={() => history.push(`${PATH_SECURITY}/${item.path}`)}
          sx={{
            pl: 4,
            "& span": {
              fontSize: "17px",
              color: isActive
                ? "#1976d2"
                : theme.palette.mode === "dark"
                ? "#fff"
                : "#3F3F3F",
            },
          }}
        >
          <ListItemText primary={item.label} />
        </ListItemButton>
      );
    }

    if (item.type === "menu") {
      const open = menuState[item.label] || false;
      return (
        <Fragment key={item.label}>
          <ListItemButton onClick={() => toggleMenu(item.label)}>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                sx: {
                  fontWeight: 600,
                  fontSize: "19px",
                  pl: 2,
                  color: theme.palette.mode === "dark" ? "#fff" : "black",
                },
              }}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.submenu.map(renderItem)}
            </List>
          </Collapse>
        </Fragment>
      );
    }

    return null;
  };

  return (
    <Grid
      container
      wrap="nowrap"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {/* Sidebar */}
      <Grid
        item
        sx={{
          flex: "0 0 240px", // fixed width sidebar
          borderRight: "1px solid #ddd",
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "#fff",
        }}
      >
        <List component="nav">{mainMenu.map(renderItem)}</List>
      </Grid>

      {/* Main Content */}
      <Grid
        item
        sx={{
          flex: 1, // take remaining space
          padding: 2,
          overflow: "auto", // prevent cutoff
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "#fff",
        }}
      >
        <Switch>
          <Route
            exact
            path={`${PATH_SECURITY}/${securityPaths.PROFILE}`}
            render={() => <SearchProfiles />}
          />
          <Route
            exact
            path={`${PATH_SECURITY}/${securityPaths.ROLEANDPERMISSION}`}
            render={() => <Permissions />}
          />
        </Switch>
      </Grid>
    </Grid>
  );
};

export default SecuritySidebar;
